<div class="chooseRfxModal-container">
  <h3 cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    {{ 'TENDER_AUCTION_LIST' | translate }}
  </h3>

  <app-universal-table
    heightSize="60vh"
    [data]="items"
    [columnDefinitions]="columns"
    [paginationOptions]="paginationOptions"
    [selectionMode]="selectionModeSingle"
    [showPagination]="true"
    [saveAllSelected]="true"
    (selectionChange)="selectProcedure($event)"
    (pageEventChange)="onPageEventChange($event)"
    (sortChange)="onSortChange($event)" />

  <div>
    <label>{{ 'ITEM_GROUPING_OPTION' | translate }}</label>
    <mat-radio-group [value]="inNewLot" (change)="inNewLotChange($event)">
      <mat-radio-button [value]="false"
        >{{ 'ALL_ITEMS_IN_ONE_LOT' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="true"
        >{{ 'EACH_ITEM_IN_A_SEPARATE_LOT' | translate }}
      </mat-radio-button>
    </mat-radio-group>
  </div>

  <div class="chooseRfxModal-footer">
    <button
      class="btn btn-secondary"
      mat-stroked-button
      (click)="outerData.close()">
      {{ 'CANCEL' | translate }}
    </button>
    <button
      class="btn-primary"
      mat-stroked-button
      [disabled]="!selectedProcedure.length || isLoading"
      (click)="choose()">
      {{ 'CHOOSE' | translate }}
    </button>
  </div>
</div>

<ng-template #createDateTemplate let-element>
  {{ element.dateCreated | date: 'dd.MM.yyyy' }}
</ng-template>
